import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory, useLocation,
  BrowserRouter as Router, useParams,
} from 'react-router-dom';
import { Button } from 'react-scroll';
import {
  setCidade, getIdCidadeEcrie, setAuthToken, setTotem, getTotem,
} from '../../api/apiFactory';
import {
  fetchCidades, fetchLimparCookie,
  fetchNomeCidade, fetchSecretarias, fetchConfiguracoes, fetchVerificarStatusCidade,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade, desfazerCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalAjuda, abrirModalLoginManifestacao, abrirModalTotemEscolhaLoginManifestacao, abrirModalTotemLoginManifestacao, resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, selectSecretaria, desfazerSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import GridBotao from '../../components/GridBotao/GridBotao';
import {
  Alerta, AppBody, AppBodyTotem, AppFragment, BreadCumbs, CampoForm,
  Container, ContainerSelecao, ContainerTotem, Divisor, Grid, GridTotem, Linha, Titulo,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { isCorClara } from '../../util/color';
import { replaceDiacritico } from '../../util/stringFactory';

const defaulValues = {
  BuscaCidade: '',
  IdEstado: '',
  NomeEstado: '',
};

const SelecionarAplicacao = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);
  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosModal = useSelector(selectModal);

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  window.onload = () => {
    dispatch(resetarModais());
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const greetings = () => {
    const hora = new Date().getHours();
    if (hora >= 0 && hora < 12) return 'Bom dia';
    if (hora >= 12 && hora < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  const checaCidadeAtiva = (id) => {
    if (getTotem() !== 'true') {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    }
  };

  useEffect(() => {
    if (getTotem() === 'true') {
      history.push('/totem');
      setTimeout(() => {
        document.querySelector('body').click();
        document.querySelector('body').focus();
        document.querySelector('body').click();
      }, 2000);
    }
    if (getTotem() !== 'true') history.push('/');
    if (dadosLogin && dadosLogin.data) {
      dispatch(desfazerConexao());
      limpaLoginAnonimo(dadosLogin);
    }

    if (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic !== 'S' && dadosCidade.configuracoes.OcultarAppZeladoria !== 'S' && !(getIdCidadeEcrie() > 0 || getIdCidadeEcrie() === null)) {
      history.push('/totem/ouvidoria');
    }
  }, []);

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      <BreadCumbs>
        <span style={{ fontWeight: 'bold' }}>{greetings()}</span>
        , qual serviço você deseja escolher?
      </BreadCumbs>
      <ContainerTotem>
        {(dadosLogin && dadosLogin.data) && (dadosCidade.configuracoes && dadosCidade.configuracoes.Totem && dadosCidade.configuracoes.Totem === 'S') && (
          <Botao
            sair
            label="Sair"
            style={{ marginRight: espacamento.pequeno }}
            onClick={() => {
              dispatch(desfazerConexao());
              dispatch(desfazerSecretaria());
              limpaLoginAnonimo(dadosLogin);
              history.push('/totem');
            }}
          />
        )}
        <GridTotem>
          <GridBotao
            totem
            selecao
            key="Ouvidoria"
            label="Ouvidoria"
            to="/totem/ouvidoria"
            img="https://eouve.com.br/svg_icons/dark/headset-boy.svg"
            size={14}
            imgWidth={50}
            imgHeight={50}
            cor="#6eb0f8"
          />
          {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S' && (
          <GridBotao
            totem
            selecao
            to="/totem/sic"
            key="Sic"
            label="Pedido de Informação (e-SIC)"
            img="https://eouve.com.br/svg_icons/dark/chat_Prancheta_1.svg"
            size={14}
            imgWidth={50}
            imgHeight={50}
            cor="#4ad166"
          />
          )}
          {/* {(getIdCidadeEcrie() > 0) && (
          <GridBotao
            totem
            selecao
            to="/totem/servicos"
            key="Serviços"
            label="Serviços"
            img="https://eouve.com.br/svg_icons/dark/servicos_.svg"
            imgWidth={50}
            imgHeight={50}
            cor="#f6e98f"
          />
          )} */}
          {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S' && (
          <GridBotao
            totem
            selecao
            to="/totem/zeladoria"
            key="Zeladoria"
            label="Zeladoria"
            img="https://eouve.com.br/svg_icons/dark/zeladoria-limpeza.svg"
            size={14}
            imgWidth={50}
            imgHeight={50}
            cor="#facd7e"
          />
          )}
        </GridTotem>
      </ContainerTotem>
      {(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Totem && dadosCidade.configuracoes.Totem === 'S') && (
        <button
          style={{
            position: 'absolute', top: 0, left: 0, background: 'white', cursor: 'pointer', border: '1px solid transparent', padding: 10,
          }}
          type="submit"
          onClick={() => { setTotem(false); history.push('/'); }}
        >
          x
        </button>
      )}
    </AppFragment>
  );
};

export default SelecionarAplicacao;
